import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import { OtpVerificationType, StudentRegistrationType } from "../Utils/Enums";
import SessionManager from "../Utils/Session";

const StudentDashboardServices = {
  login: async (email, password) => {
    try {
      const response = await axios.post(ApiConstants.login, {
        email: email.trim(),
        password: password.trim(),
      });

      if (response.status === 200) {
        const token = response.data.token;
        SessionManager.shared.setSessionToken(token);
        return response.data;
      } else if (response.status === 201) {
        return response;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  logoutDevices: async (token) => {
    try {
      const response = await axios.post(
        ApiConstants.logout,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        SessionManager.shared.logout(false);
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  verifyOTP: async (email, otp, type) => {
    try {
      const response = await axios.post(ApiConstants.verifyOtp, {
        email: email.trim(),
        otp: otp.trim(),
        type: type.trim(),
      });

      if (response.status === 200) {
        const token = response.data.token;
        type == OtpVerificationType.forgotPassword
          ? SessionManager.shared.setForgotPasswordToken(token)
          : SessionManager.shared.setSessionToken(token);
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await axios.post(ApiConstants.forgotPassword, {
        email: email.trim(),
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (newPassword) => {
    try {
      const response = await axios.post(
        ApiConstants.resetPassword,
        { newPassword: newPassword.trim() },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getForgotPasswordToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getDetails: async () => {
    try {
      const response = await axios.get(ApiConstants.getAdminDetails, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    try {
      const response = await axios.post(
        ApiConstants.changePassword,
        {
          currentPassword: currentPassword.trim(),
          newPassword: newPassword.trim(),
          confirmPassword: confirmPassword.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateProfilePic: async (file) => {
    const formData = new FormData();
    formData.append("profile_pic", file);
    try {
      const response = await axios.put(
        ApiConstants.updateProfileDetails,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //Packages

  getAllPackages: async (offset, limit) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllPackages + `?offset=${offset}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllPackagesByID: async (package_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllPackagesByID + (package_id ?? ""),
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  packagePurchase: async (
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
    referralCode
    // amount,
    // currency
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.packagePurchase,
        {
          razorpay_order_id: razorpay_order_id,
          razorpay_payment_id: razorpay_payment_id,
          razorpay_signature: razorpay_signature,
          referralCode: referralCode,
          // amount:amount,
          // currency:currency
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  createOrder: async (refferalcode, couponId, amount, currency) => {
    try {
      const response = await axios.post(
        ApiConstants.createOrder,
        {
          referralcode: refferalcode,
          couponId: couponId || "",
          amount: amount,
          currency: currency,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  checkReferralCode: async (code) => {
    try {
      const response = await axios.post(
        ApiConstants.checkReferralCode,
        { referralCode: code },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  // verifyPaymentWebhook: async (razorpay_signature) => {
  //     try {
  //         const response = await axios.post(
  //             ApiConstants.verifyPaymentWebhook,{razorpay_signature},
  //             {
  //                 headers: {
  //                     Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
  //                 },
  //             }
  //         );
  //         if (response.status === 200) {
  //             return response.data;
  //         } else {
  //             throw new Error(response.error);
  //         }
  //     } catch (error) {
  //         throw error;
  //     }
  // },

  //Add To Cart

  addToCart: async (package_id) => {
    try {
      const payload = {
        package_id,
      };
      const response = await axios.post(ApiConstants.addToCart, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      // Handle API errors here
      throw error;
    }
  },

  getAllCart: async () => {
    try {
      const response = await axios.get(ApiConstants.getAllCart, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  deleteCart: async (cart_id) => {
    try {
      const response = await axios.delete(
        ` ${ApiConstants.deleteCart}/${cart_id}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //Studymaterial
  getAllStudyMaterials: async (limit, offset, classId, medium) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllStudyMaterials +
          `?limit=${limit}&offset=${offset}&class_id=${classId}&medium=${medium}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllModuleByID: async (offset, limit, subject_id, medium) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllModuleByID +
          `?limit=${limit}&offset=${offset}&subject_id=${subject_id}&medium=${medium.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllTopics: async (module_id) => {
    try {
      const response = await axios.get(
        `${ApiConstants.getAllTopics}?module_id=${module_id}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //UpdateProfilePic
  getprofilepic: async (file) => {
    const formData = new FormData();
    formData.append("profilePicture", file);
    try {
      const response = await axios.post(ApiConstants.getprofilepic, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteprofilePicture: async () => {
    try {
      const response = await axios.delete(ApiConstants.deleteprofilePicture, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //OrderHistory
  getOrderHistory: async (offset, limit) => {
    try {
      const response = await axios.get(
        ApiConstants.getOrderHistory + `?offset=${offset}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //MockTest

  getAllMockTest: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllMockTest +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllQuestionsById: async (mockTest_id, subjectId) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllQuestionsById +
          `?mockTest_id=${mockTest_id}&subject_id=${subjectId || ""}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  submitTest: async (
    order_id,
    mockTest_id,
    package_id,
    submittedTime,
    submittedAnswers,
    subjectData,
    startTime,
    endTime,
    submittedDate
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.submitMockTest,
        {
          order_id: order_id,
          mockTest_id: mockTest_id,
          package_id: package_id,
          submittedTime: submittedTime,
          submittedAnswers: submittedAnswers,
          numberOfQuestionsData: subjectData,
          startTime, // Send initial time as startTime
          endTime, // Send endTime,
          submitted_date: submittedDate,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getShowResults: async (mockTest_id, order_id, offset, limit) => {
    try {
      const response = await axios.get(
        ApiConstants.getShowResults +
          `?mockTest_id=${mockTest_id}&order_id=${order_id}&offset=${offset}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllResultByID: async (mockTest_id, mockTestSubmissions_id, subject_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllResultByID +
          `?mockTest_id=${mockTest_id}&mockTestSubmissions_id=${mockTestSubmissions_id}&subject_id=${
            subject_id || ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllBharaSatExamQuestionsById: async (encodedId, subjectId) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllBharaSatExamQuestionsById +
          `?bharatSatExamId=${encodedId}&subject_id=${subjectId || ""}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  submitbharatSatExam: async (
    bharatSatExamId,
    eHallTicketId,
    submittedTime,
    submittedAnswers,
    subjectData,
    startTime,
    endTime,
    submittedDate
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.submitbharatSatExam,
        {
          bharatSatExamId,
          eHallTicketId,
          submittedTime: submittedTime,
          submittedAnswers: submittedAnswers,
          numberOfQuestionsData: subjectData,
          startTime, // Send initial time as startTime
          endTime, // Send endTime,
          submitted_date: submittedDate,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  // fetchBharatSatCart: async (offset, limit, searchQuery) => {
  //   try {
  //     const response = await axios.get(
  //       ApiConstants.fetchBharatSatCart +
  //         `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       return response.data;
  //     } else {
  //       throw new Error(response.error);
  //     }
  //   } catch (error) {
  //     throw error;
  //   }
  // },
};

export default StudentDashboardServices;
